import React from 'react';
import {
  QuoteLineItem, CompanyName, QuoteTypeTag, Amount,
} from '../../../common/components/redesignComponents/ResultPageComponents/v2/QuoteCostSummaryCard.styles';

function ProductInformationEurope({ processingQuote }) {
  const companyName = processingQuote !== null && processingQuote.company !== null
    ? processingQuote.company.name
    : processingQuote?.preventivas_company.company_name;

  return (
    <>
      {processingQuote !== null
                && processingQuote.quotation_data_travel_europeassistance.coverages.map(
                  (coverage, index) => (
                    <React.Fragment key={index}>
                      {coverage.enabled === 0
                                && coverage.group_id === null && (
                                <QuoteLineItem>
                                  <CompanyName>
                                    {companyName}
                                    {' '}
                                    <QuoteTypeTag>
                                      (
                                      {coverage.title}
                                      )
                                    </QuoteTypeTag>
                                  </CompanyName>
                                  <Amount>
                                    {parseFloat(
                                      coverage.coverage_amount_gros,
                                    ).toFixed(2)}
                                    {' '}
                                    €
                                  </Amount>
                                </QuoteLineItem>
                      )}
                      {processingQuote.quotation_coverages.map(
                        (cov, i) => coverage.coverage_id
                                    === cov.guarantees_slug && (
                                    <QuoteLineItem key={i}>
                                      <CompanyName>
                                        {companyName}
                                        {' '}
                                        <QuoteTypeTag>
                                          (
                                          {coverage.title}
                                          )
                                        </QuoteTypeTag>
                                      </CompanyName>
                                      <Amount>
                                        {parseFloat(
                                          coverage.coverage_amount_gros,
                                        ).toFixed(2)}
                                        {' '}
                                        €
                                      </Amount>
                                    </QuoteLineItem>
                        ),
                      )}
                    </React.Fragment>
                  ),
                )}
    </>
  );
}

export default ProductInformationEurope;
